<template>
  <span style="width: 100%">
    <span v-if="bar">
      <transition name="fade">
        <div
          v-if="loader"
          ref="bar"
          :style="{ width: barLoader ? '100%' : '0%' }"
          class="barsetup bgm-indigo"
        />
      </transition>
      <transition name="fade">
        <div v-if="fader && !fail && !failed" ref="bar" class="barsetup bgm-indigo-100" />
      </transition>
      <transition name="fade">
        <div v-if="fail" ref="bar" class="barsetup bgm-red" />
      </transition>
    </span>
    <span v-else>
      <span v-if="loader && !failed">
        <span :class="size" class="preloader pls-blue">
          <svg class="pl-circular" viewBox="25 25 50 50">
            <circle class="plc-path" cx="50" cy="50" r="10" />
          </svg>
        </span>
      </span>
      <span v-if="!loader || fail" class="f-20">
        <transition name="fade">
          <span v-if="fader && !fail && !failed">
            <i class="fa fa-check c-gray-900" />
          </span>
        </transition>
        <transition name="fade">
          <span v-if="fail">
            <i class="fa fa-times c-red" />
          </span>
        </transition>
      </span>
    </span>
  </span>
</template>

<script>
// import { jobs } from '../api/vue-api'
import { nextTick } from 'vue'

export default {
  name: 'ComponentNetworkLoader',
  props: {
    loader: {
      type: Boolean,
      required: true,
    },
    failed: {
      type: Boolean,
      required: false,
      default: false,
    },
    bar: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'default',
    },
  },
  data() {
    return {
      fader: false,
      barLoader: false,
      fail: false,
    }
  },
  watch: {
    loader() {
      if (!this.loader) {
        this.startChangeAnimation()
      } else {
        this.startBarAnimation()
      }
    },
    failed() {
      if (this.failed) {
        this.startFailedAnimation()
      }
    },
  },
  created() {},
  methods: {
    startChangeAnimation() {
      const app = this
      app.fader = true
      this.barLoader = false
      setTimeout(() => {
        app.fader = false
      }, 300)
    },
    startFailedAnimation() {
      const app = this
      app.fail = true
      this.barLoader = false
      setTimeout(() => {
        app.fail = false
      }, 1000)
    },
    startBarAnimation() {
      if (this.bar) {
        nextTick(() => {
          this.barLoader = true
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: var(--default-fade-transition);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.barsetup {
  left: 0;
  height: 1px;
  transition: width 2s;
  top: 100%;
  overflow: hidden;
}

.preloader {
  width: 50px;

  &.sm {
    width: 36px;
  }
}
</style>
